type CraftEmailHrefArgs = {
	dmName: string;
	dmEmail: string;
	ask: string;
	slug: string;
	starterDisplayName: string;
	signatureCount?: string;
	emailDm: { emailSubjectLine: string; emailBody: readonly string[] };
};

export const craftStarterEmail = ({
	ask,
	slug,
	dmName,
	dmEmail,
	starterDisplayName,
	signatureCount,
	emailDm,
}: CraftEmailHrefArgs): string => {
	const ccChangeEmail = 'decision.makers@change.org';
	const petitionUrl = `https://www.change.org/p/${slug}?utm_source=starter_emails_dm`;
	const { emailSubjectLine: subject, emailBody } = emailDm;

	const body = emailBody
		.map((line) =>
			line
				.replace('%{dmName}', dmName)
				.replace('%{ask}', ask)
				.replace('%{signatureCount}', signatureCount || '')
				.replace('%{petitionUrl}', petitionUrl)
				.replace('%{starterDisplayName}', starterDisplayName),
		)
		.join('\n\n');

	const encodedSubject = encodeURIComponent(subject);
	const encodedBody = encodeURIComponent(body);

	return `mailto:${dmEmail}?cc=${ccChangeEmail}&body=${encodedBody}&subject=${encodedSubject}`;
};
